import script from "./NavBarSavingStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarSavingStatus.vue?vue&type=script&setup=true&lang=js"

import "./NavBarSavingStatus.vue?vue&type=style&index=0&id=e7a7cc12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a7cc12"]])

export default __exports__